import {
    TableBody as ReactAriaTableBody,
    TableBodyProps,
} from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableBodyProperties<T extends object> = TableBodyProps<T> & {
    className?: string
}

export const TableBody = <T extends object>({
    className,
    ...properties
}: Readonly<TableBodyProperties<T>>) => {
    return (
        <ReactAriaTableBody
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
